






import ListPublicEvents from '@/components/Templates/User/Event/List/ListPublicEvents.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';

export default {
    name: 'CoViewPublicEventList',
    components: {
        ListPublicEvents,
    },
    computed: {
        communityName() {
            return this.$store?.state?.space?.Name;
        },
    },
};
